import { Injectable } from "@angular/core";
import { Http, Headers } from '@angular/http';
import { HeaderService } from '../http/header.service'
import { environment } from '../../../environments/environment';
import { SessionService } from "../session/session.service";
import { Contato } from "./contato";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class ContatoService {

  constructor(
    private http: Http,
    private header: HeaderService,
    private session: SessionService
  ) {}

  public getContatoInfo(): Observable<Contato> {

    let candidato = JSON.parse(this.session.getValor("dadosCandidato"));
    let body = {
      PrcLetAno: candidato.PrcLetAno,
      PrcLetSem: candidato.PrcLetSem,
      PrcTipCod: candidato.PrcTipCod,
      PrcOcoSeq: candidato.PrcOcoSeq,
      PrcOfeSeq: candidato.PrcOfeSeq,
    };

    return this.http
      .post(environment.apiGxUrl + '/WsPrcDadosFinais.svc/rest/', body, {
        headers: this.header.getHeadersGnx(),
      })
      .map((resposta: any) => {
        const retorno = resposta.json();
        const OmniChat: string | null = retorno.OmniChat;
        let OmniChatTratado: string;

        if (OmniChat && OmniChat.length > 0){
          OmniChatTratado = retorno.OmniChat
        }else{
          OmniChatTratado = "https://wa.me/+55" + retorno.NumWatts.replace(/[^\d]+/g, '')
        }
        return new Contato(
          retorno.Setor,
          retorno.NumFone.replace(/[^\d-()\s]+/g, ''),
          retorno.NumWatts.replace(/[^\d-()\s]+/g, ''),
          retorno.NumWatts.replace(/[^\d]+/g, ''),
          OmniChatTratado
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/contato/contato.service.ts